<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Kleine Schritte</h1>
                <p class="h2">Empowerment durch Entscheidungsfreiheit: Klein anfangen, Großes erreichen</p>
            </div>
            <div class="right-wrapper">
                <h2>Warum sollte langsam begonnen werden?</h2>
                <p class="text">Kleine Verbesserungen der Essgewohnheiten werden frühzeitig anerkannt.</p>
                <p class="text">Auf diese Weise werden langfristige Fortschritte erzielt, welche den Grundstein der Erfolgsgeschichte legen.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 15
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

